export default __webpack_public_path__ + "static/media/SIRI.64bd91d1.png";